import { render } from "./PedidosSeller.vue?vue&type=template&id=f3890606&scoped=true"
import script from "./PedidosSeller.vue?vue&type=script&lang=js"
export * from "./PedidosSeller.vue?vue&type=script&lang=js"

import "./PedidosSeller.vue?vue&type=style&index=0&id=f3890606&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3890606"]])

export default __exports__